module.exports = __webpack_public_path__ + "img/capsule-3@2x.1ebb5b5f.webp";